// StatView.jsx
import { useState, useEffect } from "react";
import { Image, Box } from "@chakra-ui/react";

export default function StatView({ images, imageIndex }) {
    const [imageList, setImageList] = useState([]);

    useEffect(() => {
        if (Array.isArray(images)) {
            setImageList(images);
        } else {
            console.warn("StatView: Received non-array images prop", images);
            setImageList([]);
        }
    }, [images]);

    // Determine if this is the pie chart (third image)
    const isPieChart = imageIndex === 2;

    return (
        <Box
            display="flex"
            width="100%"
            height="100%"
            position="relative"
            justifyContent="center"
            alignItems="center"
        >
            {imageList.map((image, index) => (
                <Image
                    key={index}
                    src={image}
                    alt={`Stat ${index + 1}`}
                    objectFit="contain"
                    width="100%"
                    height="100%"
                    position="absolute"
                    inset={0}
                    transform={isPieChart ? "scale(1.2)" : "none"}
                />
            ))}
        </Box>
    );
}